import React from "react";
import { MeasureRule } from "./MeetLat";

/** Meetwaarde op display-formaat: het cijfer ís het beeld. */
export function StatBlock({ value, unit, label, note, tone = "licht", size = "groot" }) {
  const donker = tone === "donker";
  const cijfer = size === "groot" ? "var(--fs-display)" : "var(--fs-h1)";
  return (
    <div>
      <div style={{ fontSize: "var(--fs-xs)", letterSpacing: "var(--ls-label)", textTransform: "uppercase",
        fontWeight: "var(--fw-medium)", color: donker ? "rgba(247,249,250,.6)" : "var(--text-soft)" }}>{label}</div>
      <div style={{ marginTop: "var(--ruimte-4)", display: "flex", alignItems: "baseline", gap: "var(--ruimte-3)",
        fontFamily: "var(--font-kop)", fontWeight: "var(--fw-semi)", letterSpacing: "var(--ls-display)",
        fontSize: cijfer, lineHeight: "var(--lh-krap)", color: donker ? "var(--text-inverse)" : "var(--text-strong)" }}>
        {value}{unit ? <span style={{ fontSize: "var(--fs-h3)", fontWeight: "var(--fw-medium)",
          color: donker ? "rgba(247,249,250,.7)" : "var(--text-soft)" }}>{unit}</span> : null}
      </div>
      <MeasureRule height={10} spacing={7} accent={donker ? "rgba(247,249,250,.35)" : "var(--lijn-sterk)"}
        style={{ marginTop: "var(--ruimte-5)" }} />
      {note ? <div style={{ marginTop: "var(--ruimte-4)", fontSize: "var(--fs-sm)",
        color: donker ? "rgba(247,249,250,.7)" : "var(--text-soft)" }}>{note}</div> : null}
    </div>
  );
}
